import React from 'react';
import {HomePage} from "./pages/home/home.page";

function App() {
  return (
    <div>
      <HomePage></HomePage>
    </div>
  );
}

export default App;
